<template>
  <b-row style="margin-top: -20px">
    <b-col col>
      <b-card title="Venda de Mercadorias" class="card-titulo-itens"/>

      <b-card :class="isGerencial || isHomolog ? 'card-itens tableItensPdvGerencialOrHomolog' : 'card-itens tableItensPdv'" id="tableItensPdv">
        <table class="table table-striped">
          <thead>
            <tr>
              <th></th>
              <th>Descrição do Produto<br>Código de Barras</th>
              <th>Unid.</th>
              <th>Qtd.</th>
              <th style="text-align: right">Total R$</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, index) in items"
              :key="'item' + index"
              :class="!i.active ? 'cancelado' : ''"
            >
              <td>{{ parseFloat(index + 1) }}</td>
              <td>
                {{ i.product.description }}
                <br>
                <small>
                  {{ i.product.barCode }}
                </small>
              </td>
              <td>{{ i.product.unitOfMeasure ? i.product.unitOfMeasure.acronym : '' }}</td>
              <td>{{ valorRealQuantidade(i.quantity, decimalQuantity) }}</td>
              <td align="right">{{ valorReal(parseFloat(i.totalPrice), decimalPrice) }}</td>
            </tr>
          </tbody>
        </table>
      </b-card>
      <blockquote/>
      <b-card class="card-total-venda">
        <b-row>
          <b-col col lg="3" style="padding: 0">
            <b-card class="card-total-left">
              <h5 style="font-weight: 600;">SubTotal</h5>
              <p v-if="valorPago != 0">Pago: R$ {{ valorSubTotalReal(valorPago) }}</p>
              <p v-if="parseFloat(valorPago) > parseFloat(total) && !!items.length">
                Troco: R$ {{ valorSubTotalReal(parseFloat(valorPago) - parseFloat(total)) }}
              </p>
            </b-card>
          </b-col>
          <b-col col lg="9" style="padding: 0">
            <b-card class="card-total-right">
              <h5 style="font-weight: 600;">
                R$ {{ !!items.length ? valorSubTotalReal(calculoTotal) : '0,00' }}
              </h5>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>

</template>

<script>
import FormatMixin from '../../../../../Application/mixins/FormatMixin';

export default {
  name: 'pdv-card-itens',
  mixins: [
    FormatMixin,
  ],
  data() {
    return {
      fields: [
        {
          key: 'currentIndex + parseFloat(1)',
          label: '',
          sortable: true,
        },
        {
          key: 'product.description',
          label: 'Descrição do Produto \n Código de Barras',
          sortable: true,
        },
        {
          key: 'quantity',
          label: 'Qtd.',
          sortable: true,
        },
        {
          key: 'totalPrice',
          label: 'Total',
          sortable: true,
        },
      ],
      calculoTotal: 0,
    };
  },
  props: {
    items: {
      default: () => [],
    },
    total: {
      default: 0,
    },
    acrescimo: {
      default: 0,
    },
    desconto: {
      default: 0,
    },
    valorPago: {
      default: 0,
    },
    decimalQuantity: {
      default: 2,
    },
    decimalPrice: {
      default: 2,
    },
    isGerencial: {
      default: false,
    },
    isHomolog: {
      default: false,
    },
  },
  watch: {
    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.calculoTotal = newValue;
      }
    },
  },
};
</script>

<style>
  .card-titulo-itens .card-title {
    margin-bottom: 0!important;
  }

  .card-titulo-itens .card-body {
      padding: 0.45rem;
  }

  .card-titulo-itens {
    background-color: #fff;
    border: 0px;
    text-align: center;
    margin-bottom: 0px;
    padding: 0;
  }

  .card-itens .card-body {
    padding: 0;
  }

  .table {
    border-bottom: solid 0px #dedede;
    margin-bottom: 0px;
  }

  .table-striped tbody tr:nth-of-type(odd) {
   /* background-color: rgb(229 245 234);*/
    background-color: var(--color-primary-table-striped);
  }

  .pdv-itens {
    padding-right: 0px;
  }

  .cancelado {
    text-decoration: line-through;
    font-style: italic;
    color: #80808099!important;
  }

  .cancelado td {
    color: #80808099!important;
  }

  .tableItensPdv {
    overflow-y: auto;
    max-height: calc(100vh - 430px);
    height: calc(100vh - 430px);
    border: 0px;
  }

  .tableItensPdvGerencialOrHomolog {
    overflow-y: auto;
    max-height: calc(100vh - 460px);
    height: calc(100vh - 436px);
    border: 0px;
  }

  .tableItensPdv th,
  .tableItensPdv td {
    padding: 8px 16px;
  }

  .tableItensPdv .table tr th {
    border-bottom: 2px solid var(--color-primary);
  }

  .tableItensPdv th {
    position: sticky;
    top: 0;
    background: #fff;
    /*color: #1f8a50;*/
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 1px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 200px rgb(229 245 234 / 19%);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--color-secondary);
  }

  .card-total-venda {
    background: transparent;
    border: 0px;
    top: 30px;
  }

  .card-total-venda .card-body {
    padding: 0rem 1rem 0rem 1rem;
  }

  .card-total-left {
    background-color: var(--color-primary);
    border-color: var(--color-primary);
    color: #fff;
    border-radius: 0px;
    border-bottom-left-radius: 20px!important;
    height: 90px;
    width: 101%;
    display: table;
    text-align: left;
  }

  .card-total-left .card-body {
    display: table-cell;
    vertical-align: middle;
  }

  .card-total-right {
    background-color: var(--color-secondary);
    border-color: var(--color-secondary);
    color: #fff;
    border-radius: 0px;
    align-items: flex-end;
    border-bottom-right-radius: 20px!important;
    height: 90px;
    width: 100%;
    display: table;
    text-align: center;
    text-align: right;
  }

  .card-total-right .card-body {
    display: table-cell;
    vertical-align: middle;
  }

  .card-total-right p, .card-total-left p{
    margin-bottom: 0;
    font-size: 0.8rem;
  }

  .card-total-right h5, .card-total-left h5{
    font-size: 1.75rem!important;
    margin-bottom: 0;
  }

  .tableItensPdv tbody tr {
    border-top-width: 1.5px;
    border-top-style: dashed;
    border-top-color: var(--color-primary);
  }

  blockquote {
    margin: 0 auto;
    position: relative;
    text-align: center;
    z-index: 1;
  }

  blockquote:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 29px;
    right: 0;
    bottom: -24px;
    left: 0;
    padding-top: 10px;
    background:
      linear-gradient(-45deg, transparent 70%, white 75% ),
      linear-gradient( 45deg, transparent 70%, white 75% );
    background-repeat: repeat-x;
    background-size: 25px 20px, 25px 20px;
    background-position: center;
  }
</style>
